import React from "react";
import Alert from '@mui/material/Alert';

function Error({ message, top = 10, bottom = 10 }) {
    if (!message) {
        return null;
    }
    return (
        <Alert
            severity="warning"
            style={{
                marginTop: top,
                marginBottom: bottom,
                width: "100%"
            }}
        >
            {message}
        </Alert>
    );
}

export default Error;
